export default [
    {
        // ログイン
        path: '/',
        component: () => import('./pages/Login.vue')
    },
    {
        // トップ
        path: '/top',
        component: () => import('./pages/Top.vue'),
        meta: {
            requiresAuth: true
        }
    },
    /********************************************************
     * 対戦データ
     *******************************************************/
    {
        // 対戦データ解析 選手リスト
        path: '/vsDataList',
        component: () => import('./pages/VsDataList.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        // 対戦データ解析
        path: '/vsData',
        component: () => import('./pages/VsData.vue'),
        meta: {
            requiresAuth: true
        }
    },
    /********************************************************
     * 投手データ
     *******************************************************/
    {
        // 投手データ解析 選手リスト
        path: '/pitchingData/List',
        component: () => import('./pages/PitchingDataList.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        // 投手データ解析 全投球サマリー
        path: '/pitchingData/Summary',
        component: () => import('./pages/PitchingDataSummary.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        // 投手データ解析 リリースポジション 投手側から
        path: '/pitchingData/ReleasePosition',
        component: () => import('./pages/PitchingDataReleasePosition.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        // 投手データ解析 過去データ
        path: '/pitchingData/Past',
        component: () => import('./pages/PitchingDataPast.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        // 投手データ解析 スピード
        path: '/pitchingData/Speed',
        component: () => import('./pages/PitchingDataSpeed.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        // 投手データ解析 スピンレート
        path: '/pitchingData/Spin',
        component: () => import('./pages/PitchingDataSpin.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        // 投手データ解析 リリース（高さ）
        path: '/pitchingData/ReleaseHeight',
        component: () => import('./pages/PitchingDataReleaseHeight.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        // 投手データ解析 リリース（横幅）
        path: '/pitchingData/ReleaseWidth',
        component: () => import('./pages/PitchingDataReleaseWidth.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        // 投手データ解析 リリース（長さ）
        path: '/pitchingData/ReleaseLength',
        component: () => import('./pages/PitchingDataReleaseLength.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        // 投手データ解析 垂直変化
        path: '/pitchingData/Vertical',
        component: () => import('./pages/PitchingDataVertical.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        // 投手データ解析 水平変化
        path: '/pitchingData/Horizontal',
        component: () => import('./pages/PitchingDataHorizontal.vue'),
        meta: {
            requiresAuth: true
        }
    },
    /********************************************************
     * 打者データ解析
     *******************************************************/
    {
        // 打者データ解析 選手リスト
        path: '/battingDataList',
        component: () => import('./pages/BattingDataList.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        // 対戦データ解析
        path: '/battingData',
        component: () => import('./pages/BattingData.vue'),
        meta: {
            requiresAuth: true
        }
    },
    /********************************************************
     * チェックリスト
     *******************************************************/
    {
        // チェックリスト
        path: '/checkList',
        component: () => import('./pages/CheckList.vue'),
        meta: {
            requiresAuth: true
        }
    },
    /********************************************************
     * 3D軌跡
     *******************************************************/
    {
        // 3D軌跡
        path: '/three',
        component: () => import('./pages/Three'),
        meta: {
            requiresAuth: true
        }
    },
    /********************************************************
     * HE
     *******************************************************/
    {
        path: '/HawkEyePitching',
        component: () => import('./pages/HE/HEPitching.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/HawkEyeBatting',
        component: () => import('./pages/HE/HEBatting.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/he/pitchingDataSummary',
        component: () => import('./pages/HE/PitchingDataSummary.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/he/pitchingCenterVelocity',
        component: () => import('./pages/HE/PitchingCenterVelocity.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/he/pitchingVarusTorque',
        component: () => import('./pages/HE/PitchingVarusTorque.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/he/pitchingEnergyAmount',
        component: () => import('./pages/HE/PitchingEnergy.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/he/pitchingEnergyTransfer',
        component: () => import('./pages/HE/PitchingEnergyTransfer.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        // 投手データ解析 過去データ
        path: '/he/pitchingDataPast',
        component: () => import('./pages/HE/PitchingDataPast.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        // 対戦データ解析
        path: '/he/battingData',
        component: () => import('./pages/HE/BattingData.vue'),
        meta: {
            requiresAuth: true
        }
    },
    /********************************************************
     * VIDEO
     *******************************************************/
    {
        // 対戦データ解析
        path: '/videoList',
        component: () => import('./pages/VideoList.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        // 対戦データ解析
        name: 'VideoPlayer',
        path: '/videoPlayer',
        component: () => import('./pages/VideoPlayer.vue'),
        meta: {
            requiresAuth: true
        }
    },
    /********************************************************
     * ピッチトンネル
     *******************************************************/
    {
        path: '/PitchiTunnelSearch',
        component: () => import('./pages/PitchiTunnelSearch'),
        meta:{
            requiresAuth:true
        }
    },{
        path: '/pitchiTunnelBallConf',
        component: () => import('./pages/PitchiTunnelBallConf'),
        meta:{
            requiresAuth:true
        }
    },{
        path: '/pitchiTunnelChangeSelect',
        component: () => import('./pages/PitchiTunnelChangeSelect'),
        meta:{
            requiresAuth:true
        }
    },{
        path: '/pitchiTunnelChangeSelectEx',
        component: () => import('./pages/PitchiTunnelChangeSelectEx'),
        meta:{
            requiresAuth:true
        }
    },{
        path: '/pitchiTunnelThresholdSelect',
        component: () => import('./pages/PitchiTunnelThresholdSelect'),
        meta:{
            requiresAuth:true
        }
    },{
        path: '/pitchiTunnelThresholdSelectEx',
        component: () => import('./pages/PitchiTunnelThresholdSelectEx'),
        meta:{
            requiresAuth:true
        }
    },
    /********************************************************
     * チェックリスト
     *******************************************************/
    {
        // チェックリスト
        path: '/ranking',
        component: () => import('./pages/Ranking.vue'),
        meta: {
            requiresAuth: true
        }
    },
    /********************************************************
     * チェックリスト
     *******************************************************/
    {
        // チェックリスト
        path: '/alert',
        component: () => import('./pages/Alert.vue'),
        meta: {
            requiresAuth: true
        }
    },
]
